
import { of as observableOf, empty as observableEmpty,  Observable } from 'rxjs'

import { mergeMap } from 'rxjs/operators'
import { connect } from 'react-redux'
import { RangeFilter, STATUS_TYPE, ARTICLE_TYPE, PHOTO_TYPE, VIDEO_TYPE } from 'interfaces'
import { getPhotos } from 'services/content/photos/actions'
import { getArticles } from 'services/content/articles/actions'
import { getStatusIdeas } from 'services/content/statuses/actions'
import { getVideos } from 'services/content/videos/actions'
import { StoreState, StoreThunkDispatch } from 'store/state'



import { FetchCuratedFolderContent, FetchCuratedFolderContentProps } from './FetchCuratedFolderContent'
import { SortBy } from 'services/content/util'
import { ContentType } from 'shared'

export interface FetchCuratedFolderPageContentProps extends FetchCuratedFolderContentProps {
  page: number
  range: RangeFilter
  sortBy?: SortBy
  skip?: ContentType[]
}

function mapStateToProps(_state: StoreState, ownProps: FetchCuratedFolderContentProps) {
  const { page, range, folder, sortBy } = ownProps as FetchCuratedFolderPageContentProps
  return {
    ...ownProps,
    hash: `folder:${folder.slug}:${page}:${range}:${sortBy || 'any'}` as string | undefined
  }
}

function mapDispatchToProps(dispatch: StoreThunkDispatch, ownProps: FetchCuratedFolderPageContentProps) {
  const { page, range, skip, statusesSeed, sortBy } = ownProps

  const skipVideos = skip && skip.find(s => s === VIDEO_TYPE)
  const skipPhotos = skip && skip.find(s => s === PHOTO_TYPE)
  const skipArticles = skip && skip.find(s => s === ARTICLE_TYPE)
  const skipStatuses = skip && skip.find(s => s === STATUS_TYPE)

  return {
    getVideos: (folderId: string) => skipVideos
      ? observableEmpty()
      : dispatch(getVideos(folderId, true, page, range, sortBy)).pipe(mergeMap(v => observableOf(...v.items))),
    getPhotos: (folderId: string) => skipPhotos
      ? observableEmpty()
      : dispatch(getPhotos(folderId, true, page, range, sortBy)).pipe(mergeMap(p => observableOf(...p.items))),
    getArticles: (folderId: string) => skipArticles
      ? observableEmpty()
      : dispatch(getArticles(folderId, true, page, range, sortBy)).pipe(mergeMap(a => observableOf(...a.items))),
    getStatusIdeas: (categoryIds: Array<string>) => {
      if (skipStatuses || categoryIds.length === 0) {
        return observableEmpty()
      }
      return dispatch(getStatusIdeas(categoryIds, page, statusesSeed)).pipe(mergeMap(s => observableOf(...s.items)))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FetchCuratedFolderContent) as any
